module.exports = __webpack_public_path__ + "img/taketomi_7.ba6013fd.jpg";